/**
 * Project : workspace
 * File    : VerifyMPinScreen.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.common.auth

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.input.TextFieldValue
import androidx.compose.ui.text.input.VisualTransformation
import androidx.compose.ui.unit.dp


import com.parmartechnologies.communication.core.handler.AuthHandler
import com.parmartechnologies.communication.core.viewModel.AuthViewModel
import com.parmartechnologies.storage.store.UserDefaults
import common.asset.ImageAsset
import component.CustomDefaultBtn
import component.input.CustomTextField
import component.loader.AppLoader
import component.navigation.TopNavBar
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch
import kotlinx.serialization.json.Json
import locale.localization
import navigation.AppNavigator
import navigation.route.auth.AuthNavRoute
import theme.ThemeColor

/**
 * Represents the verify m pin screen class.
 */

class VerifyMPinScreen {

    @Composable
    fun Content() {
        
        val viewModel = AuthViewModel()

        var password by remember { mutableStateOf(TextFieldValue("")) }
        var retypePassword by remember { mutableStateOf(TextFieldValue("")) }
        var passwordFromServer = viewModel.password.collectAsState()
        var isValidPassword by remember { mutableStateOf(false) }
        val passwordErrorState = remember {
            mutableStateOf(false)
        }
//        viewModel.goToHome = {
//            AppNavigator.shared().popAll()
//        }
        viewModel.goToHome = {
//            navigator?.popAll()
            viewModel.hideAuthContainer()
        }
        viewModel.goBack = {
            AppNavigator.shared().authController?.popBackStack()
        }
        viewModel.goToRegister = {
            AppNavigator.shared().authController?.navigate(AuthNavRoute.REGISTER)
        }
        viewModel.goToSetMPin = {
            AppNavigator.shared().authController?.navigate(AuthNavRoute.SET_MPIN)
        }
        viewModel.goToLoginWithMPin = {
            AppNavigator.shared().authController?.navigate(AuthNavRoute.VERIFY_MPIN)
        }
        viewModel.goToOtp = {
            AppNavigator.shared().authController?.navigate(AuthNavRoute.VERIFY_OTP)
        }
        /**
 * Executes the on click send otp operation.
 *
 * @receiver TODO
 * @return Unit – no return value.
 */
        fun onClickSendOtp() {
            viewModel.sendOTP(AuthHandler.shared().mobileNumber, AuthHandler.shared().dialCode)
            viewModel.goToOtp?.let { it() }
        }

        /**
 * Executes the on click continue operation.
 *
 * @receiver TODO
 * @return Unit – no return value.
 */

        fun onClickContinue() {
            if (password.text.length == 6 && viewModel.tempAuthUser.value.Password.isNotEmpty() && password.text == viewModel.tempAuthUser.value.Password) {
                UserDefaults.shared().storeCredentials(Json.encodeToString(viewModel.tempAuthUser.value))
                CoroutineScope(Job() + Dispatchers.Default).launch {
                    AuthHandler.shared().repository.isLoggedInState.emit(true)
                    viewModel.hideAuthContainer()
                }
            }
        }

        Column(modifier = Modifier.fillMaxWidth().fillMaxHeight()) {
            TopNavBar(title = localization().accountAuthentication.verifyPin, onBackPress = {
                AppNavigator.shared().goBackAuth()
            })
            AppLoader(viewModel)
            Column(
                modifier = Modifier
                    .fillMaxSize()
                    .padding(30.dp),
                horizontalAlignment = Alignment.CenterHorizontally,
            ) {
                CustomTextField(
                    placeholder = "******",
                    trailingIcon = ImageAsset.lock,
                    label = localization().accountAuthentication.sixDigitPin,
                    keyboardType = KeyboardType.Phone,
                    errorState = passwordErrorState.value,
                    visualTransformation = VisualTransformation.None
                ) { newPass ->
                    password = newPass
                }
                Spacer(modifier = Modifier.fillMaxHeight(0.3f))
                CustomDefaultBtn(
                    shapeSize = 50f,
                    btnText = localization().accountAuthentication.continueButton
                ) {
                    onClickContinue()
                }
                Spacer(modifier = Modifier.fillMaxHeight(0.3f))
                Column(
                    modifier = Modifier
                        .fillMaxSize()
                        .padding(bottom = 50.dp),
                    verticalArrangement = Arrangement.Bottom
                ) {
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(top = 30.dp),
                        horizontalArrangement = Arrangement.Center
                    ) {
                        Text(
                            text = localization().accountAuthentication.dontRememberPin,
                            color = ThemeColor.shared().TextColor
                        )
                        Text(
                            text = localization().accountAuthentication.loginWithOTP,
                            color = ThemeColor.shared().PrimaryColor,
                            modifier = Modifier.clickable {
                                onClickSendOtp()
                            })
                    }
                }
            }
        }
    }
}